// import * as XLSX from "xlsx";
// import moment from "moment";
// import React, { useState, useEffect } from "react";
// import { Button, Select } from "antd";
// import { useDispatch } from "react-redux";
// import { useTypedSelector } from "../store";
// import { getShiftRequest } from "../slices/shift";
// import { getEmployeeTemplateRequest } from "../slices/employee";

// const { Option } = Select;

// // Data shift untuk sheet 2 (Master Shift)

// // Komponen React untuk memilih bulan dan tahun
// const DownloadTemplateSchedule = () => {
//   const dispatch = useDispatch();
//   const { shiftLists, employeeLists, isChangeEmployee } = useTypedSelector(
//     (state) => {
//       return {
//         shiftLists: state.Shift.shiftLists,
//         employeeLists: state.Employee.listEmployeeTemplate,
//         isChangeEmployee: state.Employee.postEmployeeData,
//       };
//     }
//   );
//   const [monthOptions, setMonthOptions] = useState<string[]>([]);
//   const [selectedMonth, setSelectedMonth] = useState<string>(
//     moment().format("YYYY-MM")
//   );

//   useEffect(() => {
//     setMonthOptions(generateMonthOptions());
//   }, []);
//   useEffect(() => {
//     dispatch(getShiftRequest() as any);
//     dispatch(getEmployeeTemplateRequest() as any);
//   }, [isChangeEmployee]);

//   const shiftData = shiftLists;

//   // Data employee untuk sheet 3 (Master Employee)
//   const employeeData = employeeLists;

//   // Fungsi untuk membuat template Excel
//   const downloadTemplate = (selectedMonth: string) => {
//     console.log("Selected month input: ", selectedMonth); // Debugging input

//     // Pastikan input terformat "YYYY-MM"
//     if (!moment(selectedMonth, "YYYY-MM", true).isValid()) {
//       console.error("Invalid month format. Please provide 'YYYY-MM'.");
//       return;
//     }

//     const selectedDate = moment(selectedMonth, "YYYY-MM"); // Mendapatkan tanggal berdasarkan bulan yang dipilih
//     const startOfMonth = selectedDate.clone().startOf("month"); // Mendapatkan tanggal 1 bulan yang dipilih
//     const endOfMonth = selectedDate.clone().endOf("month"); // Mendapatkan tanggal terakhir bulan yang dipilih
//     const dateArray: string[] = [];

//     console.log("Start of Month: ", startOfMonth.format("YYYY-MM-DD")); // Debugging
//     console.log("End of Month: ", endOfMonth.format("YYYY-MM-DD")); // Debugging

//     // Menggunakan loop untuk menambah tanggal ke dalam dateArray
//     let currentDate = startOfMonth.clone(); // Mulai dengan tanggal pertama bulan
//     while (
//       currentDate.isBefore(endOfMonth) ||
//       currentDate.isSame(endOfMonth, "day")
//     ) {
//       console.log("Adding date: ", currentDate.format("YYYY-MM-DD")); // Debugging
//       dateArray.push(currentDate.format("YYYY-MM-DD")); // Menambahkan tanggal dengan format yang benar
//       currentDate.add(1, "days"); // Menambah hari
//     }

//     console.log("Date Array:", dateArray);

//     // Membuat sheet pertama (Attendance)
//     const attendanceData = [
//       ["employeeId", "employeeName", ...dateArray], // Header dengan tanggal
//       // ...employeeData.map(employee => [
//       //   employee.employeeId,
//       //   employee.employeeName,
//       //   ...dateArray.map(() => null) // Mengisi dengan null untuk setiap tanggal
//       // ])
//     ];

//     // Membuat sheet kedua (Master Shift)
//     const shiftSheetData = [
//       ["code", "timeIn", "timeOut"], // Header
//       ...shiftData.map((shift: any) => [
//         shift.code,
//         shift.timeIn,
//         shift.timeOut,
//       ]),
//     ];

//     // Membuat sheet ketiga (Master Employee)
//     const employeeSheetData = [
//       ["employeeId", "employeeName"], // Header
//       ...employeeData.map((employee: any) => [
//         employee.employeeId,
//         employee.employeeName,
//       ]),
//     ];

//     // Membuat workbook dengan 3 sheet
//     const wb = XLSX.utils.book_new();
//     const wsAttendance = XLSX.utils.aoa_to_sheet(attendanceData);
//     const wsShift = XLSX.utils.aoa_to_sheet(shiftSheetData);
//     const wsEmployee = XLSX.utils.aoa_to_sheet(employeeSheetData);

//     // Menambahkan sheet ke workbook
//     XLSX.utils.book_append_sheet(wb, wsAttendance, "Attendance");
//     XLSX.utils.book_append_sheet(wb, wsShift, "Master Shift");
//     XLSX.utils.book_append_sheet(wb, wsEmployee, "Master Employee");

//     // Menyimpan workbook ke dalam file Excel
//     XLSX.writeFile(
//       wb,
//       `template-schedule-${moment(selectedMonth, "YYYY-MM").format(
//         "MMMM YYYY"
//       )}.xlsx`
//     );
//   };

//   const generateMonthOptions = () => {
//     const currentYear = moment().year();
//     const nextYear = currentYear + 1;
//     const months = moment.months();
//     const monthOptions: string[] = [];

//     // Menambahkan bulan untuk tahun ini dengan urutan Januari - Desember
//     months.forEach((_, index) => {
//       monthOptions.push(`${currentYear}-${String(index + 1).padStart(2, "0")}`);
//     });

//     // Menambahkan bulan untuk tahun depan dengan urutan Januari - Desember
//     months.forEach((_, index) => {
//       monthOptions.push(`${nextYear}-${String(index + 1).padStart(2, "0")}`);
//     });

//     return monthOptions;
//   };

//   const handleChange = (value: string) => {
//     setSelectedMonth(value);
//     console.log("Selected Month:", value); // Debugging log
//   };

//   return (
//     <div>
//       <div style={{ marginBottom: 20 }}>
//         <Select
//           value={selectedMonth}
//           onChange={handleChange}
//           style={{ width: 200 }}
//         >
//           {generateMonthOptions().map((month) => (
//             <Option key={month} value={month}>
//               {moment(month, "YYYY-MM").format("MMMM YYYY")}
//             </Option>
//           ))}
//         </Select>
//       </div>
//       <Button
//         type="primary"
//         onClick={() => downloadTemplate(selectedMonth)}
//         style={{
//           backgroundColor: "#217346", // Warna hijau khas Excel
//           borderColor: "#217346", // Sesuaikan border dengan warna latar belakang
//           color: "#fff", // Warna teks putih
//         }}
//       >
//         Download Template Excel
//       </Button>
//     </div>
//   );
// };

// export default DownloadTemplateSchedule;

import * as XLSX from "xlsx";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { Button, Select } from "antd";
import { useDispatch } from "react-redux";
import { useTypedSelector } from "../store";
import { getShiftRequest } from "../slices/shift";
import { getEmployeeTemplateRequest } from "../slices/employee";

const { Option } = Select;

const DownloadTemplateSchedule = () => {
  const dispatch = useDispatch();
  const { shiftLists, employeeLists, isChangeEmployee } = useTypedSelector(
    (state) => ({
      shiftLists: state.Shift.shiftLists,
      employeeLists: state.Employee.listEmployeeTemplate,
      isChangeEmployee: state.Employee.postEmployeeData,
    })
  );

  const [monthOptions, setMonthOptions] = useState<string[]>([]);
  const [selectedMonth, setSelectedMonth] = useState<string>(
    moment().format("YYYY-MM")
  );

  useEffect(() => {
    setMonthOptions(generateMonthOptions());
  }, []);

  useEffect(() => {
    dispatch(getShiftRequest() as any);
    dispatch(getEmployeeTemplateRequest() as any);
  }, [isChangeEmployee]);

  const generateMonthOptions = () => {
    const currentYear = moment().year();
    const nextYear = currentYear + 1;
    const months = moment.months();
    const monthOptions: string[] = [];

    months.forEach((_, index) => {
      monthOptions.push(`${currentYear}-${String(index + 1).padStart(2, "0")}`);
      monthOptions.push(`${nextYear}-${String(index + 1).padStart(2, "0")}`);
    });

    return monthOptions;
  };

  const downloadTemplate = (selectedMonth: string) => {
    const selectedDate = moment(selectedMonth, "YYYY-MM");
    const startOfMonth = selectedDate.clone().startOf("month");
    const endOfMonth = selectedDate.clone().endOf("month");
    const dateArray: string[] = [];

    let currentDate = startOfMonth.clone();
    while (
      currentDate.isBefore(endOfMonth) ||
      currentDate.isSame(endOfMonth, "day")
    ) {
      dateArray.push(currentDate.format("YYYY-MM-DD"));
      currentDate.add(1, "days");
    }

    // Membuat header
    const attendanceData = [["employeeId", "employeeName", ...dateArray]];

    // Membuat workbook
    const wb = XLSX.utils.book_new();
    const wsAttendance = XLSX.utils.aoa_to_sheet(attendanceData);

    // **Menambahkan warna merah untuk Sabtu dan Minggu**
    dateArray.forEach((date, index) => {
      const colIndex = index + 2; // Mulai dari kolom ke-2 karena 0=employeeId, 1=employeeName
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIndex });

      const dayOfWeek = moment(date).day(); // 6 = Sabtu, 0 = Minggu
      if (dayOfWeek === 6 || dayOfWeek === 0) {
        // Jika cell kosong, tambahkan format teks
        if (!wsAttendance[cellAddress]) {
          wsAttendance[cellAddress] = { t: "s", v: date };
        }

        // Terapkan styling
        wsAttendance[cellAddress].s = {
          font: { color: { rgb: "FF0000" }, bold: true }, // Warna merah + bold
          alignment: { horizontal: "center" }, // Teks rata tengah
        };
      }
    });

    const masterShiftData = [
      ["Shift Code", "Shift Name", "Start Time", "End Time"],
    ];

    shiftLists.forEach((shift: any) => {
      masterShiftData.push([shift.code, shift.timeIn, shift.timeOut]);
    });

    // Membuat sheet Master Shift
    const wsMasterShift = XLSX.utils.aoa_to_sheet(masterShiftData);

    // Menambahkan sheet ke workbook
    XLSX.utils.book_append_sheet(wb, wsAttendance, "Attendance");
    XLSX.utils.book_append_sheet(wb, wsMasterShift, "Master Shift");

    // Simpan file Excel
    XLSX.writeFile(
      wb,
      `template-schedule-${moment(selectedMonth, "YYYY-MM").format(
        "MMMM YYYY"
      )}.xlsx`
    );
  };

  console.log("SL", shiftLists);

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <Select
          value={selectedMonth}
          onChange={setSelectedMonth}
          style={{ width: 200 }}
        >
          {monthOptions.map((month) => (
            <Option key={month} value={month}>
              {moment(month, "YYYY-MM").format("MMMM YYYY")}
            </Option>
          ))}
        </Select>
      </div>
      <Button
        type="primary"
        onClick={() => downloadTemplate(selectedMonth)}
        style={{
          backgroundColor: "#217346",
          borderColor: "#217346",
          color: "#fff",
        }}
      >
        Download Template Excel
      </Button>
    </div>
  );
};

export default DownloadTemplateSchedule;
